import { DialogComponent } from './../components/dialog/dialog.component';

import { RequestordersComponent } from './orders/requestorders/requestorders.component';
import { CustomerComponent } from './customers/customer/customer.component';
import { UserformComponent } from './userscompanys/userform/userform.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PagesComponent } from './pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { Graficas1Component } from './graficas1/graficas1.component';
import { ProgressComponent } from './progress/progress.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { ProfileComponent } from './profile/profile.component';
import { NopagefoundComponent } from '../shared/nopagefound/nopagefound.component';

import { EdituserformComponent } from './userscompanys/edituserform/edituserform.component';
import { CustomersComponent } from './customers/customers/customers.component';
import { CustomerformComponent } from './customers/customerform/customerform.component';
import { OrdersComponent } from './orders/orders/orders.component';
import { LoginGuardGuard } from '../services/service.index';
import { EditcustomerformComponent } from './customers/editcustomerform/editcustomerform.component';
import { RegionComponent } from './region/region.component';
import { TrackingComponent } from './drivers/tracking/tracking.component';
import { OrderdetailsComponent } from './orders/orderdetails/orderdetails.component';
import { AsignorderComponent } from './orders/asignorder/asignorder.component';
import { OrderformComponent } from './orders/orderform/orderform.component';
import { CreatecompanyComponent } from '../companys/createcompany/createcompany.component';
import { UsersComponent } from './userscompanys/users/users.component';
import { EditorderComponent } from './orders/editorder/editorder.component';
import { HistoryordersComponent } from './orders/historyorders/historyorders.component';
import { EditcarformComponent } from './cars/editcarform/editcarform.component';
import { CarsComponent } from './cars/cars/cars.component';
import { CarsformComponent } from './cars/carsform/carsform.component';
import { ClientsappComponent } from './customers/clientsapp/clientsapp.component';
import { ItemsComponent } from './itemssettings/items/items.component';
import { ItemsformComponent } from './itemssettings/itemsform/itemsform.component';
import { ItemeditComponent } from './itemssettings/itemedit/itemedit.component';


const pageRoutes: Routes = [
  {
    path: '',
    component: PagesComponent,
    canActivate: [ LoginGuardGuard ],
    children: [
      {  path: 'dashboard', component: DashboardComponent},
      {  path: 'progress', component: ProgressComponent},
      {  path: 'graficas1', component: Graficas1Component},
      {  path: 'account-settings', component: AccountSettingsComponent},
      //MANTENIMIETO
      {  path: 'photo', component: DialogComponent, data: { titulo: 'Edit Car'}},
      {  path: 'editcar/:id', component: EditcarformComponent, data: { titulo: 'Edit Car'}},
      {  path: 'items', component: ItemsComponent, data: { titulo: 'Items'}},
      {  path: 'edit-item/:id', component: ItemeditComponent, data: { titulo: 'Items'}},
      {  path: 'additems', component: ItemsformComponent, data: { titulo: 'Items'}},
      {  path: 'cars', component: CarsComponent, data: { titulo: 'Cars'}},
      {  path: 'addcar', component: CarsformComponent, data: { titulo: 'Add Cars'}},
      {  path: 'profile/:id', component: ProfileComponent, data: { titulo: 'User Profile'}},
      {  path: 'users', component: UsersComponent, data: { titulo: 'User Settings'}},
      {  path: 'editusers/:id', component: EdituserformComponent, data: { titulo: 'User Edit'}},
      {  path: 'reguser', component: UserformComponent, data: { titulo: 'User Register'}},
      {  path: 'customer', component: CustomerComponent, data: { titulo: 'User Register'}},
      {  path: 'customers', component: CustomersComponent, data: { titulo: 'User Register'}},
      {  path: 'customerform', component: CustomerformComponent, data: { titulo: 'User Register'}},
      {  path: 'editcustomer/:id', component: EditcustomerformComponent, data: { titulo: 'Edit Customer Form'}},
      {  path: 'tracking', component: TrackingComponent, data: { titulo: 'Driver Tracking'}},
      {  path: 'createOrder', component: OrderformComponent, data: { titulo: 'Order Form'}},
      {  path: 'orders', component: OrdersComponent, data: { titulo: 'User Register'}},
      {  path: 'customers-app', component: ClientsappComponent, data: { titulo: 'User Register'}},
      {  path: 'editorder/:id', component: EditorderComponent, data: { titulo: 'Edit Order'}},
      {  path: 'orderDetail/:id', component: OrderdetailsComponent, data: { titulo: 'Order Details'}},
      {  path: 'historyorders', component: HistoryordersComponent, data: { titulo: 'Order Details'}},
      {  path: 'asignOrder', component: AsignorderComponent, data: { titulo: 'Order Assign'}},
      {  path: 'requestOrder', component: RequestordersComponent, data: { titulo: 'Request Orders'}},
      {  path: 'region', component: RegionComponent, data: { titulo: 'Region Maps'}},
      {  path: '', redirectTo: '/dashboard', pathMatch: 'full'},
      //{  path: '**', pathMatch: 'full', component: NopagefoundComponent},
      //{  path: '**', component: NopagefoundComponent},
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(pageRoutes)],
  exports: [RouterModule]

})
export class PagesRoutingModule { }
